import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { IDDiagnosisListApi, IDPatientInfoApi, UpdatePatientApiRqData } from 'models/DCK/DCKApiTypes';

class ViewDetailPatientPageApi {
    async updatePatientInfo(rqData: UpdatePatientApiRqData, token: string): Promise<IDPatientInfoApi> {
        try {
            const response = await axios.put(apiPaths.updatePatient, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getPatientInfo(url: string, token: string): Promise<IDPatientInfoApi> {
        try {
            const response = await axios.get(apiPaths.getPatientInfo + url, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getPatientDiagnosisList(url: string, token: string): Promise<IDDiagnosisListApi> {
        try {
            const response = await axios.get(apiPaths.getPatientDiagnosisList + url, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async patientChangeStatus(rqData: { _id: string; status: number }, token: string): Promise<IDPatientInfoApi> {
        try {
            const response = await axios.put(apiPaths.patientChangeStatus, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async deletePatient(id: string, token: string): Promise<IDPatientInfoApi> {
        try {
            const response = await axios.delete(apiPaths.deletePatient + id, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const viewDetailPatientPageApi = new ViewDetailPatientPageApi();
